export const styles = {
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    width: '100%',
    zIndex: 1500, // Higher than MUI Dialog (1300) and Modal backdrop (1400)
    borderBottom: '1px solid',
    borderColor: 'divider',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    backgroundColor: 'white',
    animation: 'slideDown 0.3s ease-out',
    '@keyframes slideDown': {
      '0%': {
        transform: 'translateY(-100%)',
        opacity: 0,
      },
      '100%': {
        transform: 'translateY(0)',
        opacity: 1,
      },
    },
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 2,
    gap: 2,
  },
  banner: {
    borderRadius: 0,
    border: 'none',
    flex: 1,
    backgroundColor: 'transparent',
  },
  actions: {
    display: 'flex',
    gap: 2,
    flexShrink: 0,
  },
}
